export default __webpack_public_path__ + "static/media/galaxynft_banner.ffda8562.jpeg";